// removed by extract-text-webpack-plugin
module.exports = {"bg":"BRaj4","base":"_3OXNX","sectionHeader":"_1Eo3D","title":"_2kZLn","content":"ntuhs","spinner":"fshTY","list":"_3kZOn","form":"_3cuh6","group":"_2Tehr","footer":"i0nTP","item":"_217Ge","accessHeader":"_1ywrg","accessHeaderFirstColumn":"_2AKY6","icon":"_2gYl9","crossIcon":"_2tYba","access":"_2JgCX","accessDesc":"_1nKJw","accessDetails":"_1y2rc","firstColumn":"_25nvs","secondColumn":"_1QVIm"};


//////////////////
// WEBPACK FOOTER
// ./src/views/ManagePermissions/ManagePermissions.scss
// module id = 1894
// module chunks = 0